import { ModalOverlaysModule } from './pages/modal-overlays/modal-overlays.module';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import {
  NbAuthComponent,
  NbLoginComponent,
  NbLogoutComponent,
  NbRegisterComponent,
  NbRequestPasswordComponent,
  NbResetPasswordComponent,
} from '@nebular/auth';
import { AuthGuard } from './auth/auth.guard'; // ✅ Add this
import { ProfileComponent } from './pages/profile/profile.component';
import { CustomLoginComponent } from './auth/custom-login/custom-login.component';
import { UploadProfilePopupOpenerComponent } from './auth/upload-profile-popup-opener/upload-profile-popup-opener.component';
import { CustomRegisterComponent } from './auth/custom-register/custom-register.component';
import { CustomForgotPasswordComponent } from './auth/custom-forgot-password/custom-forgot-password.component';

export const routes: Routes = [
  {
    path: 'pages',
    canActivate: [AuthGuard], // 🔒 Protect all pages
    loadChildren: () =>
      import('./pages/pages.module').then(m => m.PagesModule),

  },
  {
    path: 'modal-overlays',
    canActivate: [AuthGuard], // 🔒 Protect all pages
    loadChildren: () =>
      import('./pages/modal-overlays/modal-overlays.module').then(m => m.ModalOverlaysModule),

  },
  {
    path: 'auth',
    component: NbAuthComponent,
    children: [
      { path: '', component: CustomLoginComponent },
      { path: 'login', component: CustomLoginComponent },
      { path: 'register', component: CustomRegisterComponent },
      { path: 'logout', component: NbLogoutComponent },
      { path: 'profile', component: ProfileComponent },
      { path: 'request-password', component: CustomForgotPasswordComponent },
      { path: 'reset-password', component: NbResetPasswordComponent },
      {
  path: 'upload-profile-popup',
  component: UploadProfilePopupOpenerComponent
}

    ],
  },
  { path: '', redirectTo: 'pages', pathMatch: 'full' },
  { path: '**', redirectTo: 'pages' },
];

const config: ExtraOptions = {
  useHash: false,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
